import { inject, injectable, injectFromBase } from 'inversify';
import { BaseEventListener } from '@kiplin/web-common/event';
import { NavigationDependencyTypes, type RouterInterface } from '@kiplin/web-common/navigation';
import { AuthenticationRequiredEvent } from '@shared/common/network/domain/event/authentication-required.event';
import { NetworkDependencyTypes } from '@shared/common/network/network.dependency-types';
import type { AuthenticationRequiredService } from '@shared/common/network/domain/service/authentication-required.service';
import { LoginRouteName } from '@shared/feature/login/application/routes/login.route-name';

@injectable()
@injectFromBase()
export class AuthenticationRequiredNavigationListener extends BaseEventListener<AuthenticationRequiredEvent> {
  protected readonly eventClass = AuthenticationRequiredEvent;

  public constructor(
    @inject(NetworkDependencyTypes.AuthenticationRequiredService)
    private readonly authenticationRequiredService: AuthenticationRequiredService,
    @inject(NavigationDependencyTypes.Router)
    private readonly router: RouterInterface,
  ) {
    super();
  }

  protected async handle(): Promise<void> {
    this.authenticationRequiredService.clearAuthentication();

    await this.router.push({ name: LoginRouteName.Login });
  }
}
